package pwgs.ui.scenes.customentityeditorscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class ACustomEntityEditorControllerFe(props: pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorSceneProps, scene: MCustomEntityEditorScene)
 : AController<pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorSceneProps, pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorSceneModel, CustomEntityEditorSceneState>(props, scene) {

    val backend = CustomEntityEditorControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    fun call_saveField() {
        launchOnDefaultControllerScope {
            render(backend.saveField())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class CustomEntityEditorControllerBeProxy(private val controller: ACustomEntityEditorControllerFe) {

    suspend fun load(): pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorSceneModel.serializer())
        }
    }

    suspend fun saveField(): pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorControllerBe.saveField",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.customentityeditorscene.CustomEntityEditorSceneModel.serializer())
        }
    }

}
